export default (groups, $user) => {
    return [
        {
            event: "Groups\\GroupMemberRemoved",
            callback: async (e: {group: string; user: string}) => {
                if (e.user === $user.id) {
                    groups.value = groups.value.filter((group) => group.id !== e.group);
                }
            },
        },
    ];
};
